import localFont from 'next/font/local'

const titleFont = localFont({src: './fonts/Autumn in November.ttf'})

export default titleFont;
